import { Button } from '@progress/kendo-react-buttons';
import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';
import addIcon from './assets/img/icon/add.png';
import removeIcon from './assets/img/icon/remove.png';

type Props = {
  onClickBack?: MouseEventHandler<HTMLButtonElement>;
  onClickNxt?: MouseEventHandler<HTMLButtonElement>;
  classNameBack?: string;
  classNameNxt?: string;
  className?: string;
  back?: string;
  next?: string;
  disableNext?: boolean;
  disableBack?: boolean;
  buttonTheme?: 'light' | 'dark';
  showIcon?: boolean;
  srcAdd?: string | undefined;
  srcRemove?: string | undefined;
};

export const AddRemoveIconButton = ({
  onClickBack,
  onClickNxt,
  classNameBack,
  classNameNxt,
  className,
  back,
  next,
  disableNext,
  disableBack,
  buttonTheme,
  srcAdd,
  srcRemove,
}: Props) => {
  return (
    <Wrapper className={className}>
      <Button
        className={`btn-back ${classNameBack} ${buttonTheme}`}
        onClick={onClickBack}
        disabled={disableBack}
      >
        <ButtonTextWrapper>
          <ImageWrapper className="image-wrapper">
            <img src={srcRemove} />
          </ImageWrapper>
          <p>{back}</p>
        </ButtonTextWrapper>
      </Button>
      <Button
        className={`btn-nxt ${classNameNxt} ${
          disableNext ? 'disableNext' : ''
        }`}
        onClick={onClickNxt}
        disabled={disableNext}
      >
        <ButtonTextWrapper>
          <ImageWrapper className="image-wrapper">
            <img src={srcAdd} />
          </ImageWrapper>
          <p>{next}</p>
        </ButtonTextWrapper>
      </Button>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  button {
    width: fit-content;
    min-width: 100px;
    height: 27px;
    margin: 0px 10px;
    border-radius: 6px;
    box-shadow: none !important;
    outline: none !important;
    font-family: 'Roboto';
    width: 50%;
    &.btn-back {
      background-color: #d40000;
      border: 1px solid #606060;
      color: #909090;
      padding: 5px;
      &.light {
        background-color: #ededed;
      }
      &.dark {
        background-color: #2a2a2a;
      }
    }
    &.btn-nxt {
      background-color: #001fff;
      border: 1px solid #2a2a2a;
      color: #ffffff;
      padding: 5px;
    }
    &.disableNext {
      background: #9e9ea0 !important;
      opacity: 1 !important;
      /* color: #9e9ea0 !important; */
    }
  }
  @media (min-width: 100px) and (max-width: 319px) {
    button {
      min-width: 65px;
      height: 30px;
      font-size: 9px;
    }
  }
  @media (min-width: 320px) and (max-width: 576px) {
    button {
      min-width: 70px;
      font-size: 10px;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    button {
      min-width: 75px;
      font-size: 13px;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    button {
      min-width: 75px;
      font-size: 13px;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    button {
      min-width: 80px;
      font-size: 14px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
  }
  @media (min-width: 1449px) and (max-width: 1719px) {
  }
  @media (min-width: 1720px) and (max-width: 4000px) {
  }
`;
const ButtonTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const ImageWrapper = styled.div`
  height: auto;
  width: 16px;
  img {
    height: 100%;
    width: 100%;
  }
`;
